export default __webpack_public_path__ + "static/media/eraser.62f9149c.svg";